import { Controller } from 'stimulus';
const TomSelect = require('../lib/tom_select');

export default class extends Controller {
  static targets = ['field'];

  _setupAutocomplete() {
    const { url } = this.fieldTarget.dataset;
    const labelField = this.fieldTarget.dataset.label;

    this.tomSelect = new TomSelect(this.fieldTarget, {
      valueField: 'id',
      labelField: 'text',
      searchField: 'text',
      load: (query, callback) => {
        const fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set('query', query);
        fetch(fetchUrl)
          .then(response => response.json())
          .then(data => {
            callback(data.map(obj => ({ id: obj.id, text: obj[labelField] })));
          })
          .catch(() => { callback(); });
      },
    });
  }

  connect() {
    this._setupAutocomplete();
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
      this.tomSelect = null;
    }
  }
}
